import { render, staticRenderFns } from "./ChooseAcid.vue?vue&type=template&id=7924fa7d&"
import script from "./ChooseAcid.vue?vue&type=script&lang=js&"
export * from "./ChooseAcid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports